/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Thumbnail_Prompt_NoInputs */



/**
* | output |
* | --- |
* | "No, skip" |
*
* @param {Scene_Change_Detection_Thumbnail_Prompt_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_prompt_no = /** @type {((inputs?: Scene_Change_Detection_Thumbnail_Prompt_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Prompt_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non, passez votre chemin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nein, überspringen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("No, salta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет, пропустить")
	if (locale === "es") return /** @type {LocalizedString} */ ("No, salta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不，跳过")
	if (locale === "ja") return /** @type {LocalizedString} */ ("いいえ、スキップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नहीं, छोड़ दो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não, pule")
	return /** @type {LocalizedString} */ ("No, skip")
});